import { makeAutoObservable, runInAction } from 'mobx';
import { createContext } from 'react';
import { LocalStore } from 'zf-web-infra';
import { SharedStore } from 'zf-web-shared';
import { CONFIG } from 'config';
import { RootService, ThemeService } from '@services';
import type { UserInfo } from './types';

export class RootStore {

  // 用户信息，包括基本信息+租户信息，登录后会保存到这，也可调用 refreshUser 方法更新
  user?: UserInfo = undefined;

  /**
   * 通过 SharedStore 来保存一些全局状态，需要与微应用共享的状态放在这里
   */
  shared: SharedStore;

  /**
   * 通过 LocalStore 来保存一些本地状态
   */
  local: LocalStore;

  service: RootService;

  constructor() {
    makeAutoObservable(this, {
      shared: false,
      local: false,
      service: false
    });
    this.service = new RootService();
    this.local = new LocalStore();
    this.shared = new SharedStore();
  }

  setSharedStore(shared: SharedStore): void {
    this.shared = shared;
  }

  async refreshUser(): Promise<void> {
    try {
      const app = new ThemeService(this.local).getAppFromHostName(location.hostname);
      const user = await this.service.getUser({ app });
      runInAction(() => {
        this.user = user;
        this.local.code = user.code;
        this.local.id = user.id;
        this.shared.setUser(user);
      });
    } catch {
      console.warn('get user info failed');
    }
  }

  getIsHideMenuAndHeader(): boolean {
    return CONFIG.BACKEND_HIDE_MENU_HOST.includes(location.hostname);
  }

}

export const RootContext = createContext<RootStore>(new RootStore());
export const RootProvider = RootContext.Provider;
